import { Component } from '@angular/core';

@Component({
  selector: 'trustsuite-centered',
  templateUrl: './centered.component.html',
  styleUrls: ['./centered.component.scss'],
})
export class CenteredComponent {}
